export default __webpack_public_path__ + "static/media/480_business01-nl-web.a38b3298.png";